<template>
  <div class="audio-item d-flex">
    <div class="audio-item--left d-flex align-items-center justify-content-center" @click="playPause">
      <font-awesome-icon :icon="playIcon" />
    </div>
    <div class="audio-item--right">
      <div :id="`audio-attachment-${attachmentId}`" class="wave-surfer-container" />
      <div class="audio-item--status d-flex align-items-center justify-content-between">
        <div class="volume-control d-flex align-items-center">
          <div class="volume-icon-wrapper d-flex align-items-center justify-content-start">
            <font-awesome-icon :icon="volumeIcon" />
          </div>
          <b-form-input
            type="range"
            min="0"
            max="100"
            :value="volume"
            :disabled="!isReady"
            @change="changeVolume"
          />
        </div>
        <div class="duration">
          {{ `${currentTime}/${duration}` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import WaveSurfer from "wavesurfer.js";

export default {
  name: "AudioItem",
  props: {
    attachmentId: {
      type: String,
      required: true,
    },
    audioUrl: {
      type: String,
      default: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
    },
  },
  data() {
    return {
      waveSurfer: null,
      options: {
        container: `#audio-attachment-${this.attachmentId}`,
        height: 20,
        fillParent: true,
        splitChannels: false,
        normalize: false,
        waveColor: "#263238",
        progressColor: "#186dde",
        cursorColor: "transparent",
        cursorWidth: 1,
        barWidth: 1,
        barGap: 1,
      },
      loading: false,
      currentTime: `--:--`,
      durationTime: 0,
      volume: 0,
    };
  },
  computed: {
    duration() {
      if (!this.loading && this.waveSurfer) {
        return this.convertTime(this.durationTime);
      }
      return '--:--';
    },
    isReady() {
      return !this.loading && this.waveSurfer;
    },
    isPlaying() {
      if (this.isReady && this.waveSurfer.isPlaying()) {
        return true;
      }
      return false;
    },
    volumeIcon() {
      if (this.volume > 0 && this.volume < 50)
        return 'fas fa-volume-down';
      if (this.volume >= 50)
        return 'fas fa-volume-up';
      return 'fas fa-volume-off';
    },
    playIcon() {
      return this.isPlaying ? 'fas fa-pause' : 'fas fa-play';
    }
  },
  mounted() {
      this.loading = true;
      this.waveSurfer = WaveSurfer.create(this.options);

      this.waveSurfer.load(this.audioUrl);

      this.waveSurfer.on('ready', () => {
        this.loading = false;
        this.durationTime = this.waveSurfer.getDuration();
        this.currentTime = this.convertTime(0);
        this.waveSurfer.setVolume(0.4);
        this.volume = 40;
      })

      this.waveSurfer.on('audioprocess', (currentTime) => {
        if (this.waveSurfer.isPlaying()) {
          this.currentTime = this.convertTime(currentTime)
        }
      })

      console.log("this.waveSurfer", this.waveSurfer);
  },
  methods: {
    convertTime(time) {
      let timeValue = Math.trunc(time);
      if (this.durationTime > 3599) {
        const hours = Math.trunc(timeValue / 3600).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        timeValue -= 3600 * Math.trunc(timeValue / 3600);
        const minutes = Math.trunc(timeValue / 60).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        const seconds = Math.trunc(timeValue % 60).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        return `${hours}:${minutes}:${seconds}`;
      } else {
        const minutes = Math.trunc(timeValue / 60).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        const seconds = Math.trunc(timeValue % 60).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        return `${minutes}:${seconds}`;
      }
    },
    playPause() {
      if (this.isReady) {
        this.waveSurfer.playPause();
      }
    },
    changeVolume(volume) {
      if (this.isReady) {
        this.volume = volume;
        this.waveSurfer.setVolume(volume / 100)
      }
    }
  },
  beforeDestroy() {
    if (this.waveSurfer) {
      this.waveSurfer.destroy();
    }
  }
};
</script>

<style lang="scss">
.audio-item {
  width: 100%;
  height: 60px;
  min-width: 360px;
  background-color: #e9edf2;
  border-radius: 8px;

  &--left {
    width: 60px;
    cursor: pointer;
  }

  &--right {
    width: calc(100% - 68px);

    .wave-surfer-container {
      height: 20px;
      margin: 5px 0;

    }

    .audio-item--status {
      height: 30px;

      .volume-control {
        .volume-icon-wrapper {
          width: 20px;
          height: 20px;
          color: #263238;
        }

        input[type=range] {
          width: 60px;

          &::-webkit-slider-thumb {
            background-color: #263238;
            width: 12px;
            height: 12px;
            cursor: pointer;
            margin-top: -2px;
          }

          &::-moz-range-thumb {
            background-color: #263238;
          }

          &::-ms-thumb {
            background-color: #263238;
          }
        }
      }

      .duration {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}
</style>